import type { ScopeFieldsContent } from '@/blocks/domain/types/BlockContent/ScopeFieldsContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';

export function mapScopeFieldsContent(dto: Extract<BlockContentDto, { kind: 'scope_fields' }>): ScopeFieldsContent {
  return { kind: 'scope_fields', title: dto.title };
}

export function fromScopeFieldsContent(content: ScopeFieldsContent): Extract<BlockContentDto, { kind: 'scope_fields' }> {
  return { kind: 'scope_fields', title: content.title };
}
